import { hsmBackendClient } from './client';
import { CreditLine, IControllerResponse } from './types';

export interface PostCreditLineInput {
  messageQty: number;
}

/**
 * Sets the credit line for the given company. Hits
 * `POST /company/{companyId}/credit-line` and returns the resulting
 * `CreditLine`. The endpoint **overwrites** the available balance — to
 * add to the balance, the admin must purchase an add-on instead.
 */
export async function postCreditLine(
  companyId: string,
  input: PostCreditLineInput
): Promise<CreditLine> {
  const response = await hsmBackendClient.post<IControllerResponse<CreditLine>>(
    `/company/${encodeURIComponent(companyId)}/credit-line`,
    input
  );

  if (!response.data.result) {
    throw new Error(
      response.data.message ?? 'Respuesta del backend sin result'
    );
  }
  return response.data.result;
}
